<template>
  <div>
    <header :style="style">
      <overlay :isActive="showOverlay" @closed="setShowOverlay(false)"></overlay>
      <top-menu @open-overlay="setShowOverlay(true)" />
    </header>
    <section class="container-fluid p-0">
      <slot />
    </section>
    <!-- <page-footer/> -->
  </div>
</template>
<script>
import TopMenu from "./../shared/TopMenu.vue";
import overlay from "./overlay.vue";
import { mapGetters, mapMutations } from "vuex";
//import PageFooter from "./../shared/footer.vue";
export default {
  components: {
    TopMenu,
    //PageFooter,
    overlay
  },
  data() {
    return {
      style: {
        "min-height": this.isWC() ? "80px" : "0"
      }
    };
  },
  computed: {
    ...mapGetters(["showOverlay"])
  },
  methods: {
    ...mapMutations(["setShowOverlay"])
  }
};
</script>
